import React, {useState} from 'react';
import {Document, Page, Text, View, Image} from "@react-pdf/renderer";
import styles from "./style";
import photo from '../../assets/logoMEAWithText.png'
import {weekList} from "../../services/listItems";
import {URLPhp} from '../../services/url';
import caseCoche from '../../assets/caseCoche.png';

const RecapPDF = ({pvi, id, pviEBP}) => {
    const afficherElementAvecCaseACocher = (value) => {
        return <Text><Image
            source={caseCoche}
            style={styles.caseCoche}
        /> {value}</Text>
    }
    const section = (titre, tab) => {
        return <div>
            <div style={styles.enteteDiv}>
                <Text>{titre}</Text>
            </div>
            <div style={styles.responseEncadrant}>
                {JSON.parse(tab).map((value, index) => {
                    if (value != "") {
                        return afficherElementAvecCaseACocher(value)
                    }
                })}
            </div>
        </div>
    }

    const sectionInstall = (titre, tab) => {
        return <div>
            <div style={styles.enteteDiv}>
                <Text>{titre}</Text>
            </div>
            <div style={styles.responseEncadrant}>
                {titre === "Description" && <>
                        {tab.map((value, index) => {
                            if(value.title === true){
                                return <>
                                    {value.children.length > 0 ?
                                        <Text style={{ display: "flex",justifyContent: 'start', alignItems:"flex-start",textAlign: "left", textDecoration: "underline", fontWeight: "bold", color: '#000000'}} key={index}>
                                            {value.description}
                                        </Text>
                                        :
                                        <Text style={{ textAlign: "left", color: '#000000'}} key={index}>
                                            {value.description}
                                        </Text>
                                    }
                                    {value.children.map((value1, index1) => {
                                        return <Text style={{ textAlign: "left", color: '#000000'}} key={index1}>
                                            {value1.DescriptionClear}
                                        </Text>
                                    })}
                                </>

                            }
                        })}
                    </>
                    ||
                    <Text>{tab}</Text>
                }
            </div>
        </div>
    }

    const HeaderPage = () => {
        return <View fixed={true}>
            <div style={styles.header}>
                <div style={styles.headerLeft}>
                    <div>
                        <Image
                            source={photo}
                            style={{width: '150px', padding: '10px'}}
                        />
                    </div>
                    <div style={styles.headerInfo}>
                        <div style={styles.headerTitle}>
                            <Text>Maintenance Entretien Aéraulique</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>www.mea-air.fr</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>445 boulevard Gambetta</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>Tour Mercure</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>59200 Tourcoing</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>Tél. : 03 20 10 81 80</Text>
                        </div>
                        <div style={styles.headerTitle}>
                            <Text>contact@mea-air.fr</Text>
                        </div>
                    </div>
                </div>
                <div style={styles.headerRight}>
                    <div style={styles.headerInfo}>
                        <Text style={styles.headerIntervention}>Procès-verbal d'intervention</Text>
                        <Text style={styles.headerIntervention}>Établi le
                            : {new Date(pvi.date_pvi).toLocaleDateString()}</Text>
                        <Text style={styles.headerIntervention}>N° Dossier : {pviEBP.NumDossier}</Text>
                        <Text style={styles.headerIntervention}
                              render={({pageNumber, totalPages}) => "Page : " + pageNumber + "/" + totalPages
                              }/>
                    </div>
                </div>
            </div>
        </View>
    }

    const FooterPage = () => {
        return <View fixed={true}>
            <div style={styles.conditions}>
                <Text>EURL MEA Maintenance Entretien Aéraulique - 50 000 € de capital - SIRET 80820801100011</Text>
                <Text>445 Boulevard Gambetta – Tour Mercure 59200 Tourcoing - N° TVA FR17808208011</Text>
                <Text>T. 03 20 10 81 80 - contact@mea-air.fr </Text>
                <Text>www.mea-air.fr </Text>
            </div>
        </View>
    }

    const ImageWrapper = ({ src }) => {
        try {
            // Essayez de charger l'image et retournez-la si tout va bien
            return <Image src={src} style={{ padding: "10px 0", width: "350px", maxHeight: "500px" }} />;
        } catch (error) {
            // En cas d'erreur (404 ou autre), renvoyez un composant vide
            return null;
        }
    };

    return (
        <Document
            title={"Evenement"}
            subject={"Evenement"}
        >
            <Page size={"A4"} style={styles.page}>
                <HeaderPage wrap={true}/>
                <View>
                    <div style={styles.information}>
                        <div style={styles.informationLeft}>
                            <div style={styles.informationClient}>
                                <Text style={styles.titleUnderLine}>Chantier :</Text>
                            </div>
                            <div style={styles.informationAdresse}>
                                <Text>{pviEBP.LieuIntervention} </Text>
                                <Text>Adresse : {pviEBP.AdresseIntervention}</Text>
                            </div>
                            <div style={styles.informationContact}>
                                <Text style={styles.titleUnderLine}>Contact :</Text>
                            </div>
                            <div style={styles.informationAdresse}>
                                <Text>{pvi.interlocuteur} </Text>
                                <Text>Téléphone : {pviEBP.TelephonePortable}</Text>
                            </div>
                            <div style={styles.informationInterlocuteur}>
                                <Text>Technicien : {pvi.nom} {pvi.prenom}</Text>
                            </div>

                        </div>
                        <div style={styles.informationSpace}></div>
                        <div style={styles.informationRight}>
                            <div style={styles.informationClient}>
                                <Text style={styles.titleUnderLine}> Client :</Text>
                            </div>
                            <div style={styles.infoClient}>
                                <Text>{pviEBP.Client} </Text>
                            </div>
                            <div style={styles.informationLieu}>
                                {pviEBP.AdresseIntervention.split(",").map(e => <Text>{e}</Text>)}
                            </div>
                        </div>
                    </div>
                </View>
                <View>
                    <div style={styles.enteteCadrant}>
                        <Text>Descriptif des travaux réalisés</Text>
                    </div>
                    <div style={styles.imputation}>
                        <div style={styles.imputationLeft}>
                            <div>
                                <Text>Opération Réalisé : </Text>
                            </div>
                            <div>
                                <Text> {pvi.num_imputation}</Text>
                            </div>
                        </div>
                        <div style={styles.imputationRight}>
                            <Text> Travaux terminés : {pvi.travaux_fini === "non" ? "Non" : "Oui"}</Text>
                        </div>
                    </div>
                    <div style={styles.imputation}>
                        <div style={styles.informationLeft}>
                            <Text> Plan de prévention : {pvi.plan_prevention}</Text>
                            <div style={styles.response}>
                                {JSON.parse(pvi.mep_chantier).map((value, index) => {
                                    return afficherElementAvecCaseACocher(value)
                                })}
                            </div>
                        </div>
                        <div style={styles.informationRight}>
                            <Text> Équipements pris en charge :</Text>
                            <div style={styles.response}>
                                {JSON.parse(pvi.installation).map((value, index) => {
                                    return afficherElementAvecCaseACocher(value)
                                })}
                            </div>
                        </div>
                    </div>
                    {(JSON.parse(pvi.entr_hotte).toString() === "" || !JSON.parse(pvi.installation).includes("Hotte")) ? null :
                        section("Entretien Hotte", pvi.entr_hotte)
                    }
                    {(JSON.parse(pvi.entr_evap).toString() === "" || !JSON.parse(pvi.installation).includes("Évaporateur")) ? null :
                        section("Entretien Évaporateur", pvi.entr_evap)
                    }
                    {(JSON.parse(pvi.cta).toString() === "" || !JSON.parse(pvi.installation).includes("CTA")) ? null :
                        section("Entretien CTA", pvi.cta)
                    }
                    {(JSON.parse(pvi.vmc).toString() === "" || !JSON.parse(pvi.installation).includes("Caissons VMC")) ? null :
                        section("Entretien VMC", pvi.vmc)
                    }
                    {JSON.parse(pvi.aerotherme).toString() === "" ? null :
                        section("Entretien Aérotherme", pvi.aerotherme)
                    }
                    {(JSON.parse(pvi.clim).toString() === "" || !JSON.parse(pvi.installation).includes("Climatisation")) ? null :
                        section("Entretien Climatisation", pvi.clim)
                    }
                    {(JSON.parse(pvi.condenseur).toString() === "" || !JSON.parse(pvi.installation).includes("Condenseur")) ? null :
                        section("Entretien Condenseur", pvi.condenseur)
                    }
                    {(JSON.parse(pvi.radiant).toString() === "" || !JSON.parse(pvi.installation).includes("Radiant")) ? null :
                        section("Entretien Radiant", pvi.radiant)
                    }
                    {(JSON.parse(pvi.textile).toString() === "" || !JSON.parse(pvi.installation).includes("Gaine textile")) ? null :
                        section("Entretien Gaine textile", pvi.textile)
                    }
                    {(JSON.parse(pvi.ligneProd).toString() === "" || !JSON.parse(pvi.installation).includes("Ligne production")) ? null :
                        section("Ligne production", pvi.ligneProd)
                    }
                    {(JSON.parse(pvi.chaudiere).toString() === "" || !JSON.parse(pvi.installation).includes("Chaudière")) ? null :
                        section("Chaudière", pvi.chaudiere)
                    }
                    {(JSON.parse(pvi.chaudiereTypeB).toString() === "" || !JSON.parse(pvi.chaudiere).includes("Chaudière à circuit de combustion non étanche (type B):")) ? null :
                        section("Chaudière Type B", pvi.chaudiereTypeB)
                    }
                    {pvi.num_imputation === "Installation" && <>
                        {sectionInstall("Typologie", pvi.install_typologie)}
                        {sectionInstall("Description", JSON.parse(pvi.install_desc))}
                    </>
                    }
                    {(!JSON.parse(pvi.installation).includes("Autre")) ? null :
                        <div>
                            <div style={styles.enteteDiv}>
                                <Text>Entretien</Text>
                            </div>
                            <div style={styles.responseEncadrant}>
                                <Text>{pvi.autre}</Text>
                            </div>
                        </div>
                    }
                    <div>
                        <div style={styles.enteteDiv}>
                            <Text>Commentaire</Text>
                        </div>
                        <div style={styles.responseEncadrant}>
                            <Text>{pvi.commentaire != '' ? pvi.commentaire : "Pas de commentaire"}</Text>
                        </div>
                    </div>
                    <div>
                        <div style={styles.enteteDiv}>
                            <Text>Réception des travaux</Text>
                        </div>
                        <div style={styles.responseEncadrant}>
                            {pvi.reserve === "Cette réception est prononcée sans réserve" &&
                                <Text style={styles.question}>Cette réception est prononcée sans réserve</Text>
                                ||
                                <div>
                                    <Text style={styles.question}>Cette réception est prononcée avec les réserves
                                        suivantes : </Text>
                                    <Text style={styles.response}>{pvi.reserve_text}</Text>
                                </div>
                            }
                        </div>
                    </div>
                    {pvi.comm_effectuer != "" && <>
                        <div>
                            <div style={styles.enteteDiv}>
                                <Text>A effectuer : {pvi.effectuer}</Text>
                            </div>
                            <div style={styles.responseEncadrant}>
                                <Text>{pvi.comm_effectuer}</Text>
                            </div>
                        </div>
                    </>}
                </View>
                {(pvi.num_imputation === "Installation" && pvi.install_mep !== "") && <>
                    <Text style={{fontSize: 12}}>La mise en service a été effectuée</Text>
                </>}
                <View>
                    <View wrap={false}>
                        <div style={styles.footer}>
                            <div style={styles.signatures}>
                                <div style={styles.signatureFooter}>
                                    <Text>{pviEBP.Contact}</Text>
                                    <Text>Signature du client :</Text>
                                    <Image
                                        src={URLPhp + '/' + pvi.sign_client}
                                        style={{width: "100%", padding: "5px"}}
                                    />
                                </div>
                                <div style={styles.signatureFooter}>
                                    <Text>{pvi.nom} {pvi.prenom}</Text>
                                    <Text>Signature du technicien :</Text>
                                    <Image
                                        src={URLPhp + '/' + pvi.sign_tech}
                                        style={{width: "100%", padding: "5px"}}
                                    />
                                </div>
                            </div>
                        </div>
                    </View>
                {/*    <View wrap={false} style={styles.dateView}>*/}
                {/*        <div style={styles.date}>*/}
                {/*            <div style={styles.entete}>*/}
                {/*                <div style={styles.dayCaseClean}>*/}
                {/*                </div>*/}
                {/*                <div style={styles.dateCase}>*/}
                {/*                    <Text>Date</Text>*/}
                {/*                </div>*/}
                {/*                <div style={styles.tempsPasseCase}>*/}
                {/*                    <Text>Horaires</Text>*/}
                {/*                    <Text>Matin</Text>*/}
                {/*                </div>*/}
                {/*                <div style={styles.tempsPasseCase}>*/}
                {/*                    <Text>Horaires</Text>*/}
                {/*                    <Text>Après-Midi</Text>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*            {JSON.parse(pvi.horaires_inter).map(d => <>*/}
                {/*                <div style={styles.ligneTableau}>*/}

                {/*                    <div style={styles.dayCase}>*/}
                {/*                        <Text>{weekList[new Date(d.date).getDay()]}</Text>*/}
                {/*                    </div>*/}
                {/*                    <div style={styles.dateCaseClean}>*/}
                {/*                        <Text>{new Date(d.date).toLocaleDateString()}</Text>*/}
                {/*                    </div>*/}
                {/*                    <div style={styles.tempsPasseCaseClean}>*/}
                {/*                        <Text>{d.heure_matin_debut} - {d.heure_matin_fin}</Text>*/}
                {/*                    </div>*/}
                {/*                    <div style={styles.tempsPasseCaseCleanRight}>*/}
                {/*                        <Text>{d.heure_am_debut} - {d.heure_am_fin}</Text>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </>)}*/}
                {/*        </div>*/}
                {/*    </View>*/}
                </View>
                <FooterPage/>
            </Page>
            {(pvi.photos != "" && pvi.photos != null && pvi.photos != '""') &&
                <Page size={"A4"} style={styles.page}>
                    <HeaderPage key={2} wrap={true}/>
                    {(pvi.photos != "" && pvi.photos != null) &&
                        <View style={styles.contentImages}>
                            {JSON.parse(pvi.photos).map(p => {
                            return <span style={{display: "flex", flexDirection: 'column',justifyContent: "center", alignItems:"center",}}>
                                <Text style={{display: "flex",  fontSize: 12}} break={true}>{p.description != undefined && p.description}</Text>
                                <Image  style={{padding: "10px 0", width: "350px", maxHeight: "500px"}}
                                        src={p.name ? (URLPhp + "/Import/InterN" + id + "/img/" + p.name) : (URLPhp + "/Import/InterN" + id + "/img/" + p)}
                                />
                            </span>} )}
                        </View>
                    }
                    <FooterPage/>
                </Page>
            }
        </Document>
    );
};

export default RecapPDF;